import React from 'react'
import { CloudinaryProvider } from './src/context/cloudinary-context'

export const wrapRootElement = ({ element }) => (
  <CloudinaryProvider>{element}</CloudinaryProvider>
)

// Use Default Browser Behavior
export const shouldUpdateScroll = () => false
 